import { Injectable } from '@angular/core';
import { AppDaoService } from '../app-dao.service';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';

const STORAGE_PREFIX = 'app-service_';
const STORAGE_KEY_TOKENID = 'tokenId';
const STORAGE_KEY_BUILDVERSION = 'buildVersion';

@Injectable()
export class AppStorageDaoService implements AppDaoService {
  // Lifecycle
  constructor(private storage: KeyValuePersistenceService) {}

  // AppDaoService
  public async loadTokenId(): Promise<string> {
    return await this.storage.load(STORAGE_PREFIX + STORAGE_KEY_TOKENID);
  }
  public async saveTokenId(tokenId: string): Promise<void> {
    await this.storage.store(STORAGE_PREFIX + STORAGE_KEY_TOKENID, tokenId);
  }

  public async loadBuildVersion(): Promise<string | number> {
    return await this.storage.load(STORAGE_PREFIX + STORAGE_KEY_BUILDVERSION);
  }
  public async saveBuildVersion(buildVersion: string | number): Promise<void> {
    await this.storage.store(
      STORAGE_PREFIX + STORAGE_KEY_BUILDVERSION,
      buildVersion
    );
  }

  // Resetable

  public async reset() {
    // Do nothing
  }

  public async clear() {
    await this.storage.delete(STORAGE_PREFIX + STORAGE_KEY_TOKENID);
  }
}
